import Details from './details/IncidentPictureDetailsInitialState'

const { Record } = require('immutable')

export default Record({
    details: Details()
})